module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAACCAYAAAAqyZ49AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACqSURBVChTTU5bDsIwDHOyTQj2yxHgpFyES/HPAcYHHwhRtw1uh8QsRXYS52GXs1/D7GQBGowVQUjDwIBq0uErA5Gi+ZQ3dvXDXHO15wASwjIcydtc8w4r1zB6ZMYwdj0FUgmyVnCYwFLAqczk4cV9PvL9WYi79lR90qBnTM91rQNb6jDoTGN3DWw79cfa4TA1u6/0yp87xhHIwE6eEr/DW8yKJ/DA0tMbYF/WYmg5PYladwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/couponImg/line-right.png
// module id = G1nv
// module chunks = 0